import { PaymentStatus } from '@src/types/payment';

interface OrderStatusTagProps {
  status?: PaymentStatus;
}
export function OrderStatusTag({ status }: OrderStatusTagProps) {
  switch (status) {
    case 'success':
      return (
        <div className='text-success bg-success/20 p-1 font-bold text-B-12 rounded-md'>
          Complete
        </div>
      );
    case 'pending':
      return (
        <div className='text-warning bg-warning/20 p-1 font-bold text-B-12 rounded-md'>
          Pending
        </div>
      );
    case 'failed':
      return (
        <div className='text-error bg-error/20 p-1 font-bold text-B-12 rounded-md'>
          Failed
        </div>
      );
    default:
      return (
        <div className='text-warning bg-warning/20 p-1 font-bold text-B-12 rounded-md'>
          Pending
        </div>
      );
  }
}
